import { render, staticRenderFns } from "./DingDeptDrawer.vue?vue&type=template&id=68c995d4&scoped=true"
import script from "./DingDeptDrawer.vue?vue&type=script&lang=js"
export * from "./DingDeptDrawer.vue?vue&type=script&lang=js"
import style0 from "./DingDeptDrawer.vue?vue&type=style&index=0&id=68c995d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c995d4",
  null
  
)

export default component.exports